import React from 'react'

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 15.94C19.45 15.94 19 16.39 19 16.94V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6C19 6.55 19.45 7 20 7C20.55 7 21 6.55 21 6C21 4.35 19.65 3 18 3H6C4.35 3 3 4.35 3 6V18C3 19.65 4.35 21 6 21H18C19.65 21 21 19.65 21 18V16.94C21 16.39 20.55 15.94 20 15.94Z"
      fill="#2E2D37"
    />
    <path
      d="M21.9 11.4001C22 11.1601 22 10.8801 21.9 10.6401C21.85 10.5201 21.78 10.4101 21.68 10.3101L18.66 7.29006C18.27 6.90006 17.64 6.90006 17.25 7.29006C16.86 7.68006 16.86 8.31006 17.25 8.70006L18.56 10.0101H17.22C12.25 9.97006 10.71 14.0001 10.26 15.7401C10.12 16.2701 10.45 16.8201 10.98 16.9601C11.07 16.9901 11.15 17.0001 11.23 17.0001C11.68 17.0001 12.08 16.7001 12.2 16.2501C12.7 14.3001 13.96 12.0201 17.21 12.0201H18.56L17.25 13.3301C16.86 13.7201 16.86 14.3501 17.25 14.7401C17.45 14.9401 17.7 15.0301 17.96 15.0301C18.22 15.0301 18.47 14.9301 18.67 14.7401L21.69 11.7201C21.77 11.6301 21.85 11.5201 21.9 11.4001Z"
      fill="#2E2D37"
    />
  </svg>
)
